import React from 'react';
import { Tag, TagProps } from '../Tag/Tag';

export default function PickerTag(props: TagProps) {
  return <Tag {...props} />;
}
